import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: '24px 0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  })
);

interface Props {
  children: React.ReactNode;
}

function NoResultsText(props: Props & TypographyProps) {
  const classes = useStyles({});
  const { children, ...other } = props;
  return (
    <div className={classes.container}>
      <Typography {...other}>{children}</Typography>
    </div>
  );
};

export default NoResultsText;
